import GuestService from "./service";

export * from "./reqres";

export default GuestService;
